import React from 'react';
import PropTypes from 'prop-types';
import './FieldCheckbox.sass';

import cx from 'classnames';

export default function FieldCheckbox({input, meta: {touched, error} = {}, children, label, className, disabled, ...rest}) {
  const displayError = (touched && error);

  return (
    <div className={cx('field-checkbox', className, disabled && 'field-checkbox--disabled')}>
      <div className="field-checkbox__input-wrap">
        <label className="field-checkbox__name">
          <input checked={!!input.value} {...rest} {...input} type="checkbox" className="field-checkbox__input"/>
          <span className="field-checkbox__name-text">{children}</span>
        </label>

        {displayError && (<div className="field-checkbox__error-message">{error}</div>)}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/fields/fieldCheckbox/FieldCheckbox.js